import SelectPaymentMethod from './SelectPaymentMethod'

export default SelectPaymentMethod
